import { HttpResult } from 'widgets-for-react'
import { parsePhoneNumber } from '../../../../../utils/phoneNumber'
import { Centrum, Department } from '../../../cmsPageState'
import { transformDepartmentPageData, transformCentrumPageData } from '../../../sharepointPageApi/transformers/pageDataToPage'
import { CentrumData, CentrumPageData, DepartmentData, DepartmentPageData } from '../../../sharepointPageApi/types/pageData'
import { ConsultationOverview, KindOfWaitingTimes, WaitingTimesByKind } from './waitingTimesBlockState'
import { ConsultationTimes } from './waitingTimesBlockState'

export const getCentrumPage = async (slug: string): Promise<HttpResult<Centrum>> => {
  const res = await fetch(`/api/v1/pages/centra/${slug.toLowerCase()}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: CentrumPageData = await res.json()

  const centrum = transformCentrumPageData(data)['centrum']

  if (centrum === undefined)
    return {
      kind: 'failed',
      status: res.status,
    }

  return {
    kind: 'result',
    status: 200,
    value: centrum,
  }
}

export const getDepartmentPage = async (slug: string): Promise<HttpResult<Department>> => {
  const res = await fetch(`/api/v1/pages/departments/${slug.toLowerCase()}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: DepartmentPageData = await res.json()

  const department = transformDepartmentPageData(data)['department']

  if (department === undefined)
    return {
      kind: 'failed',
      status: res.status,
    }

  return {
    kind: 'result',
    status: 200,
    value: department,
  }
}

type ConsultationOverviewData = {
  Department?: DepartmentData,
  Centrum?: CentrumData
  Locations: WaitingTimeData[]
}

type WaitingTimesByDepartmentOrCentrumData = {
  Kind: KindOfWaitingTimes
  WaitingTimes: {
    Name: string
    Locations: WaitingTimeData[],
  }[]
}

type WaitingTimeData = {
  Location: string
  Days: number
}

export const getConsultationsOverviewWaitingTimes = async (): Promise<HttpResult<ConsultationOverview>> => {
  const res = await fetch(`api/v1/waiting-times/consultations/locations`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: ConsultationOverviewData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => ({
      department: item.Department && {
        id: item.Department.SharepointId, 
        title: item.Department.Title, 
        appointmentUrl: item.Department.AppointmentURL,
        phoneNumbers: [{ description: item.Department.Description1, ...parsePhoneNumber(item.Department.PhoneNumber1?.PhoneNumber ?? "") }],
      },
      centrum: item.Centrum && { 
        title: item.Centrum.Title, 
      },
      locations: item.Locations.map((item) => ({
        location: item.Location,
        time: item.Days
      })),
    })),
  }
}

export const getConsultationsWaitingTimes = async (forPage: "centrum" | "department", title: string): Promise<HttpResult<ConsultationTimes>> => {
  const res = await fetch(`/api/v1/waiting-times/consultations/${forPage}/${title}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: WaitingTimeData[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => ({
      time: item.Days,
      location: item.Location
    })),
  }
}

export const getWaitingTimesByDepartmentOrCentrum = async (forPage: "centrum" | "department", title: string): Promise<HttpResult<WaitingTimesByKind>> => {
  const res = await fetch(`/api/v1/waiting-times?forPage=${forPage}&title=${title}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: WaitingTimesByDepartmentOrCentrumData[] = await res.json()
  return {
    kind: 'result',
    status: 200,
    value: data.map((item) => ({
      kind: item.Kind,
      waitingTimes: item.WaitingTimes.map((item) => ({
        name: item.Name,
        locations: item.Locations.map((item) => ({
          location: item.Location,
          time: item.Days
        })),
      })),
    })),
  }
}
